/**
 *
 * MultiStep
 *
 */

import { Component } from "react";
import * as PropTypes from "prop-types";
import styled from "styled-components";
import {
  RefrezhStepIcon,
  RefrezhStepperConnector,
} from "components/RefrezhStepperConnector/RefrezhStepperConnector";
import { Step, StepLabel, Stepper } from "@material-ui/core";
import history from "utils/history";

function noop() {}

class MultiStep extends Component {
  static propTypes = {
    steps: PropTypes.array.isRequired,
    currentStep: PropTypes.number,
    onStepChange: PropTypes.func,
    stepProps: PropTypes.object,
    showProgress: PropTypes.bool,
    initialStep: PropTypes.number,
    shouldReset: PropTypes.bool,
  };

  static defaultProps = {
    stepProps: {},
    showProgress: true,
    onStepChange: noop,
    initialStep: 0,
    shouldReset: true,
  };

  state = {
    step: this.props.initialStep,
  };

  componentDidMount() {
    if (this.props.initialStep !== this.state.step) {
      this.setState({
        step: this.props.initialStep,
      });
    }
    this.checkControlled();
  }

  /**
   * Throw an error if there are invalid props for a controller component.
   */
  checkControlled() {
    if (
      typeof this.props.currentStep === "number" &&
      !this.props.onStepChange
    ) {
      throw Error("Controlled component needs onStepChange handler");
    }
  }

  /**
   * Reset to the first step.
   */
  reset(step = 0) {
    if (!this.isControlled) {
      this.setState({
        step,
      });
    }
    this.props.onStepChange(step);
  }

  get isControlled() {
    return typeof this.props.currentStep === "number";
  }

  get currentStep() {
    if (this.isControlled) {
      return this.props.currentStep;
    }
    return this.state.step;
  }

  /**
   * When the next button is clicked, change step to the next step.
   */
  handleNext = () => {
    const { step } = this.state;
    const newStep = step + 1;
    if (newStep >= this.props.steps.length) {
      return;
    }
    if (!this.isControlled) {
      this.setState({
        step: newStep,
      });
    }
    if (this.props.onStepChange) {
      this.props.onStepChange(newStep);
    }
  };

  /**
   * When the back button is clicked, change step to the previous step.
   */
  handleBack = () => {
    const { step } = this.state;
    const newStep = step - 1 + this.props.initialStep;
    if (newStep === 0) {
      if (this.props.shouldReset && this.props.onReset) {
        this.props.onReset();
      }
      let parts = location.href.split('/')
      history.push(`/patient/${parseInt(parts[parts.length - 1])}`);
    }

    if (newStep < 0) {
      return;
    }
    if (!this.isControlled) {
      this.setState({
        step: newStep,
      });
    }
    if (this.props.onStepChange) {
      this.props.onStepChange(newStep);
    }
  };

  colors = ["#23667d", "#1d845f", "#5F021F"];

  render() {
    const Current = this.props.steps[this.currentStep];
    const steps = [];

    for (let i = 0; i < this.props.steps.length; i++) {
      steps.push(
        <Step key={i}>
          <StepLabel
            StepIconComponent={RefrezhStepIcon}
            StepIconProps={{
              color: this.colors[i],
              index: i + 1,
              disabledColor: "#C8D9DE",
            }}
          />
        </Step>,
      );
    }

    return (
      <Wrapper>
        <Current
          {...this.props.stepProps}
          onBack={this.handleBack}
          onNext={this.handleNext}
          showModal={this.props.modal}
        />
        {this.props.showProgress && (
          <Stepper
            connector={<RefrezhStepperConnector />}
            alternativeLabel
            activeStep={this.currentStep}
            style={{ width: "100%",background:'#ffffff00' }}
          >
            {steps}
          </Stepper>
        )}
      </Wrapper>
    );
  }
}

export default MultiStep;

const Wrapper = styled.div`
  width: 100%;
  min-height: inherit;
  padding-bottom: ${({ theme }) => theme.padding}rem;
`;
